import { deleteFavorite } from '../../services';
import { favoriteQueue } from '../utils/queue';

export async function deleteFavoriteChannel(id: number) {
  await favoriteQueue.enqueue(() => deleteFavorite({ id }));
}
